import classNames from 'classnames'
import { memo, useState } from 'react'
import Dropdown from 'react-bootstrap/Dropdown'
import DropdownButton from 'react-bootstrap/DropdownButton'
import { v4 } from 'uuid'

import Icon from '@/components/Icon/Icon'
import { useTheme } from '@/components/ThemeProvider/ThemeProvider'
import { DEFAULT_FILTER_VALUE, DEFAULT_FILTER_VALUE_MAP, FilterType, NAME_MAP } from '@/types/additionalFilters'

import styles from './AdditionalFiltersButton.module.scss'

type Props = {
  filters: FilterType[]
  setFilters: (filters: FilterType[]) => void
}

const AdditionalFiltersButton = ({ filters, setFilters }: Props) => {
  const [showDropdown, setShowDropdown] = useState(false) // Manually control dropdown visibility so we can hide the tooltip
  const [theme] = useTheme()

  const changeFilter = (filter: keyof typeof DEFAULT_FILTER_VALUE_MAP, i: number) => {
    const newValues = DEFAULT_FILTER_VALUE_MAP[filter] || DEFAULT_FILTER_VALUE
    setFilters([
      ...filters.slice(0, i),
      {
        focus: true,
        key: v4(),
        type: filter,
        values: newValues,
      },
      ...filters.slice(i + 1),
    ])
  }

  return (
    <DropdownButton
      className='ml-2'
      onSelect={(e) => changeFilter(e as keyof typeof DEFAULT_FILTER_VALUE_MAP, filters.length + 1)}
      onToggle={(nextShow) => setShowDropdown(nextShow)}
      show={showDropdown}
      size='sm'
      title={<Icon icon='filter' />}
      variant={theme}
    >
      {[
        'cardName',
        'typeLine',
        'colors',
        'manaValue',
        'power',
        'toughness',
        'rarity',
        'sets',
        'tags',
        'price',
        'salt',
        'inclusion',
        'num_decks',
        'synergy',
      ].map((value) => (
        <Dropdown.Item
          className={classNames({ [styles.bold]: filters.some((f) => f.type === value) })}
          eventKey={value}
          key={value}
        >
          {NAME_MAP[value as keyof typeof NAME_MAP]}
        </Dropdown.Item>
      ))}
    </DropdownButton>
  )
}

export default memo(AdditionalFiltersButton)
